import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import _ from 'lodash';

import { CURRENT_USER_AUTHOR_LABEL } from 'constants/pendingChangesAuthors';
import { getPersonInitials } from 'utils/loanApplication';

import { AI_INITIALS, LAST_CHANGE_PREFIX } from './PendingChangesAuthorsMenu.constants';

dayjs.extend(relativeTime);

const getAuthorInitials = ({ isAi, name }) => {
  if (isAi) {
    return AI_INITIALS;
  }

  const [firstName = '', ...lastNameParts] = (name || '').split(' ');

  return getPersonInitials({ firstName, lastName: lastNameParts.join(' ') });
};

const getAuthorSubtitle = author => {
  if (author.isCurrentUser) {
    return _.compact([author.name, author.role]).join(' · ');
  }

  if (author.isAi) {
    return author.starterLabel || '';
  }

  return author.lastChangeDate
    ? `${LAST_CHANGE_PREFIX} ${dayjs(author.lastChangeDate).fromNow()}`
    : '';
};

export const buildAuthorMenuRows = ({ authors, selectedAuthorKeys }) =>
  authors.map(author => ({
    key: author.key,
    color: author.color,
    initials: getAuthorInitials(author),
    title: author.isCurrentUser ? CURRENT_USER_AUTHOR_LABEL : author.name || '',
    role: author.isCurrentUser ? null : author.role,
    subtitle: getAuthorSubtitle(author),
    changesCount: author.changesCount,
    isSelected: selectedAuthorKeys.includes(author.key),
  }));
